import { PropsWithChildren } from "react";
import Discord from "../../assets/logos/discord.svg";
import Charmverse from "../../assets/logos/charmverse.png";

import { links } from "../../utils/links";
import { Link } from "../Actions";

export const DiscordBanner: React.FC<PropsWithChildren<{}>> = ({
  children
}) => {
  return (
    <div className="border-t-[1px] border-coinage-stroke mt-2">
      <div className="bg-coinage-white border-coinage-purple rounded-md border-2 flex flex-col tab:flex-row p-6 gap-2 tab:gap-8 max-w-5xl items-center mt-8 text-center tab:text-left">
        <p className="body1 text-coinage-black mb-1">{children}</p>
      </div>
    </div>
  );
};
